interface HoldingAccount {
  InstitutionName?: string;
  AccountName?: string;
}

/**
 * Names the account a holding sits in, led by its institution the way the holdings grid and the
 * legacy portal title accounts. An account named after its institution is shown once, and a row
 * with no account (a category bucket) has no label.
 */
export const holdingAccountLabel = ({
  InstitutionName,
  AccountName,
}: HoldingAccount): string => {
  if (!AccountName) return '';
  if (!InstitutionName || InstitutionName === AccountName) return AccountName;
  return `${InstitutionName}: ${AccountName}`;
};
